<template>
  <div class="drugstores-stage">
    <div>


      <div class="row top-space">
        <ul class="nav nav-tabs">
          <li class="nav-item common-tab">
            <a :class="drugstoresTabClass" aria-current="page" @click="openDrugstoresList('LOCAL')">Lista aptek</a>
          </li>
          <li class="nav-item common-tab">
            <a :class="drugstoresGroupsTabClass" @click="openDrugstoresList('GROUPS')">Grupy aptek</a>
          </li>
          <li class="nav-item common-tab">
            <a :class="drugstoresOnlineTabClass" @click="openDrugstoresList('ONLINE')">Apteki online</a>
          </li>
          <li class="nav-item common-tab">
            <a :class="drugstoresApiKeysTabClass" @click="openDrugstoresList('API-KEYS')">Klucze API aptek</a>
          </li>
        </ul>
        <div class="top-space">
          <div v-if="currentDrugstoresContext === 'LOCAL'" class="mb-3 windows-like-breadcrumb-card shadow-sm">
            <DrugstoresList :multiselect="true" :enableRowSelection="false"/>
          </div>
          <div v-else-if="currentDrugstoresContext === 'GROUPS'" class="mb-3 windows-like-breadcrumb-card shadow-sm">
            <DrugstoreGroupsList/>
          </div>
          <div v-else-if="currentDrugstoresContext === 'ONLINE'" class="mb-3 windows-like-breadcrumb-card shadow-sm">
            <div v-if="commonModule.centralInstance">
              <PresenceListView/>
            </div>
            <div v-else>
              <div class="alert alert-danger" role="alert">Widok niedostepny dla lokalnej instancji</div>
            </div>


          </div>
          <div v-else-if="currentDrugstoresContext === 'API-KEYS'" class="mb-3 windows-like-breadcrumb-card shadow-sm">
            <div v-if="commonModule.centralInstance">
              <DrugstoreApiKeysList/>
            </div>
            <div v-else>
              <div class="alert alert-danger" role="alert">Widok niedostepny dla lokalnej instancji</div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

import DrugstoresList from "./DrugstoresList.vue";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {mapStores} from "pinia";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";
import PresenceListView from "@/views/DrugstoreCommonManager/PresenceListView.vue";
import DrugstoreApiKeysList from "@/views/DrugstoreCommonManager/DrugstoreApiKeysList.vue";
import DrugstoreGroupsList from "@/views/DrugstoreCommonManager/DrugstoreGroupsList.vue";

export default {
  name: "DrugstoresStage",
  components: {
    DrugstoreGroupsList,
    DrugstoreApiKeysList,
    PresenceListView,
    DrugstoresList,

  },
  data() {
    return {
      drugstoresTabClass: "nav-link active",
      drugstoresGroupsTabClass: "nav-link",
      drugstoresOnlineTabClass: "nav-link",
      drugstoresApiKeysTabClass: "nav-link",
      currentDrugstoresContext: "LOCAL",
    };
  },
  computed: {
    simplepharmAuth() {
      return useSimplepharmAuthModule();
    },
    commonModule() {
      return useCommonAppModule();
    },
    lazyloaderModule() {
      return useLazyLoaderModule();
    }
  },
  methods: {
    openDrugstoresList(context) {
      this.currentDrugstoresContext = context;
      this.drugstoresTabClass = 'nav-link';
      this.drugstoresGroupsTabClass = 'nav-link';
      this.drugstoresOnlineTabClass = 'nav-link';
      this.drugstoresApiKeysTabClass = 'nav-link';

      if (context === 'LOCAL') {
        this.drugstoresTabClass = 'nav-link active';
      } else if (context === 'GROUPS') {
        this.drugstoresGroupsTabClass = 'nav-link active';
      } else if (context === 'ONLINE') {
        this.drugstoresOnlineTabClass = 'nav-link active';
      } else if (context === 'API-KEYS') {
        this.drugstoresApiKeysTabClass = 'nav-link active';
      }
    }
  },
  watch: {},
  mounted() {
    this.commonModule.setHorizontalNavbarTitle(`<i class="bx bx-home-circle me-1"></i> Apteki`)
  },
  created() {
    this.simplepharmAuth.refreshToken().then(() => {
      this.commonModule.httpGetLicensedFeatures();
      this.commonModule.httpGetWorkingProfile();
    });
  },
};
</script>

<style scoped>
.drugstores-stage {
  margin-left: 16px;
  margin-right: 16px;
}

.top-space {
  padding-top: 8px;
}

.common-tab {
  cursor: pointer;
}

.add-drugstore-btn {
  margin-right: 4px;
  margin-bottom: 16px;
}

.import-action-btn {
  margin-right: 4px;
  margin-bottom: 16px;
}

</style>
